
import ExpertiseTile from "../ExpertiseTile";

export default function Expertise({ expertise, isActive, onClick, isDesktop, index = 0 }) {
	return (
		<ExpertiseTile
			expertise={expertise}
			isDesktop={isDesktop}
			index={index}
			isSelected={isActive}
			onClick={() => onClick(expertise.id)}
		/>
	);
}
